import axios from 'axios';
import { PROCESS_AUTOMATION_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

export const saveRelease = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/operation/release/save`, data, {
      headers: {
        ...commonRequestHeaders(),
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error in save opeation:', error);
    throw error;
  }
};

export const getStatus = async (key) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/operation/release/status`, {
      headers: {
        ...commonRequestHeaders(),
        Authorization: `Bearer ${token}`,
      },
      params: { key },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching status:', error);
    throw error;
  }
};

export const loadReleaseRequestByKey = async (key) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/operation/release/load`, {
      headers: {
        ...commonRequestHeaders(),
        Authorization: `Bearer ${token}`,
      },
      params: { key },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching release request:', error);
    throw error;
  }
};

export const resetStatus = async (key) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/operation/release/reset`, {
      headers: {
        ...commonRequestHeaders(),
        Authorization: `Bearer ${token}`,
      },
      params: { key },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching status:', error);
    throw error;
  }
};
